import { isLocalStorageAvailable } from 'utils/storage'

const storageKey = (accountSlug: string) => `${accountSlug}_notificationsLastSeen`

export function readNotificationsLastSeen(accountSlug: string): string | null {
    if (!isLocalStorageAvailable()) {
        return null
    }
    return localStorage.getItem(storageKey(accountSlug))
}

export function markNotificationsSeen(accountSlug: string) {
    if (!isLocalStorageAvailable()) {
        return
    }
    localStorage.setItem(storageKey(accountSlug), new Date().toISOString())
}
